import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Section, SectionTitle } from './Section';
const ROWS: Array<{
  before: string;
  after: string;
}> = [{
  before: 'Usas tu iPhone solo para lo básico',
  after: 'Dominas funciones avanzadas con confianza'
}, {
  before: 'Tu batería dura pocas horas',
  after: 'Sabes cómo optimizarla y mejorarla'
}, {
  before: 'Tienes apps desordenadas y fotos acumuladas',
  after: 'Tu iPhone está limpio, organizado y fácil de usar'
}, {
  before: 'No sabes cómo proteger tu información',
  after: 'Tus datos, cuentas y privacidad están protegidos'
}, {
  before: 'Tus fotos salen oscuras o sin estilo',
  after: 'Capturas imágenes más limpias y profesionales'
}, {
  before: 'Te sientes perdido con iCloud, AirDrop y Atajos',
  after: 'Los usas con facilidad y te ahorran tiempo'
}, {
  before: 'Buscas tutoriales sueltos en internet',
  after: 'Tienes todo en una guía ordenada y completa'
}, {
  before: 'Sientes que no aprovechas tu iPhone',
  after: 'Por fin sientes que vale cada peso que pagaste'
}];
export function BeforeAfter() {
  return <Section className="bg-ink-900" data-id="element-53" data-mp="t3i1eamrv60m">
      <SectionTitle eyebrow="Transformación" data-id="element-54" data-mp="t270qjomiedq">
        Así se ve tu vida antes y después de Diccionario Apple
      </SectionTitle>

      <div className="overflow-hidden rounded-3xl border border-white/8" data-id="element-55" data-mp="170dov83rt007">
        <div className="grid grid-cols-2 bg-ink-950" data-id="element-56" data-mp="1246ft6g2v8e1">
          <div className="px-5 py-4 text-xs font-bold uppercase tracking-[0.18em] text-white/40 sm:px-7" data-id="element-57" data-mp="edj56des24ns">
            Antes
          </div>
          <div className="px-5 py-4 text-xs font-bold uppercase tracking-[0.18em] text-accent-soft sm:px-7" data-id="element-58" data-mp="9gkfc725cjve">
            Después
          </div>
        </div>

        {ROWS.map((row, index) => <div key={row.before} className={`grid grid-cols-2 border-t border-white/8 ${index % 2 === 0 ? 'bg-ink-900' : 'bg-ink-900/50'}`} data-id="element-59" data-mp="jcdmtc10dn6b" data-mpi={index}>
            <div className="px-5 py-5 text-sm leading-relaxed text-white/45 sm:px-7 sm:text-base" data-id="element-60" data-mp="3rqm7zz17bbog">
              {row.before}
            </div>
            <div className="flex items-start gap-3 px-5 py-5 text-sm leading-relaxed text-white sm:px-7 sm:text-base" data-id="element-61" data-mp="1qriz7fr6kdni">
              <ArrowRightIcon className="mt-1 hidden h-4 w-4 shrink-0 text-accent sm:block" aria-hidden="true" data-id="element-62" data-mp="1voj3pm8dt8ci" />
              <span data-id="element-63" data-mp="20hcasgrbosrr">{row.after}</span>
            </div>
          </div>)}
      </div>
    </Section>;
}